import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListJobScheduleMonitor = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListJobScheduleMonitor`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
